import React from 'react';
import '../less/swift-new.less';
import banner_img from '../img/swift_banner_img.png';
import attention_icon from '../img/wu/attention_icon.svg';
import Hero from '../../../../../auxiliary-components/shared/HeroBlock';
import QuestionsAdminNew from '../../../../../auxiliary-components/shared/QuestionsAdminNew';
import FAQStorybook from '@abank/abank-faq';
import InfoBlock from '../../../../../auxiliary-components/shared/InfoBlock';
import { ReactSVG } from 'react-svg';
import TransferTableNew from '../../../../../auxiliary-components/shared/TransfersTableNew';
import CustomDropdownNew from '../../../../../auxiliary-components/shared/CustomDropdownNew';
import TitleBlock from '../../../../../auxiliary-components/shared/TitleBlock';
import FilesForDownloadNew from '../../../../../auxiliary-components/shared/FilesForDownloadNew/views/file.c';
import Tooltip from '../../../../../auxiliary-components/shared/Tooltip';
import { filterByEnvironment } from '../../../../../helpers/utils/environmentFilter';
import wartimeTariffsData from '../enums/swift/wartime_tariffs_data.json';

export default function template() {
  const page = 'swift-new';

  const hero_data = {
    title: 'SWIFT_TITLE',
    text: 'SWIFT_DESC_1',
    link: null
  };

  const questionsWidget = this.widgetsHelper.getWidget.call(this, 'questions');

  const tooltipContent = (
    <ul className="how-to-block-list">
      <li className="how-to-block-list-item">{this.l10n("SWIFT_TOOLTIP_ITEM_1")}</li>
      <li className="how-to-block-list-item">{this.l10n("SWIFT_TOOLTIP_ITEM_2")}</li>
      <li className="how-to-block-list-item">{this.l10n("SWIFT_TOOLTIP_ITEM_3")}</li>
      <li className="how-to-block-list-item" dangerouslySetInnerHTML={{__html: this.l10n('SWIFT_TOOLTIP_ITEM_4')}}></li>
      <li className="how-to-block-list-item">{this.l10n("SWIFT_TOOLTIP_ITEM_5")}</li>
    </ul>
  );

  const tooltip = this.state.tooltipDisplay ?
    (
      <Tooltip element={this.state.tooltipElement} display={this.state.tooltipDisplay ? 'flex' : 'none'}>
        {tooltipContent}
      </Tooltip>
    ) : '';

  // Create data objects for TransferTableNew components
  const purposeBlockData = {
    title: "SWIFT_PURPOSE_BLOCK_TITLE",
    headers: ["SWIFT_PURPOSE_BLOCK_ITEM_TYPE_1", "SWIFT_PURPOSE_BLOCK_ITEM_TEXT_1"],
    columns: ["type", "text"],
    data: [
      {
        id: 1,
        type: "SWIFT_PURPOSE_BLOCK_ITEM_TYPE_2",
        text: "SWIFT_PURPOSE_BLOCK_ITEM_TEXT_2"
      },
      {
        id: 2,
        type: "SWIFT_PURPOSE_BLOCK_ITEM_TYPE_3",
        text: "SWIFT_PURPOSE_BLOCK_ITEM_TEXT_3"
      },
      {
        id: 3,
        type: "SWIFT_PURPOSE_BLOCK_ITEM_TYPE_4",
        text: "SWIFT_PURPOSE_BLOCK_ITEM_TEXT_4"
      }
    ]
  };

  const purposeStarListData = {
    title: "SWIFT_PURPOSE_BLOCK_STAR_LIST_TITLE",
    items: [
      "SWIFT_PURPOSE_BLOCK_STAR_LIST_ITEM_1",
      "SWIFT_PURPOSE_BLOCK_STAR_LIST_ITEM_2"
    ]
  };

  const tariffBlockData = {
    title: "SWIFT_TARIFFS_TITLE",
    headers: ["SWIFT_TARIFF_HEADER_TYPE", "SWIFT_TARIFF_HEADER_TEXT"],
    columns: ["type", "text"],
    data: [
      {
        id: 1,
        type: "SWIFT_TARIFF_BLOCK_ITEM_TYPE_1",
        text: "SWIFT_TARIFF_BLOCK_ITEM_TEXT_1"
      },
      {
        id: 2,
        type: "SWIFT_TARIFF_BLOCK_ITEM_TYPE_2",
        text: "SWIFT_TARIFF_BLOCK_ITEM_TEXT_2"
      },
      {
        id: 3,
        type: "SWIFT_TARIFF_BLOCK_ITEM_TYPE_3",
        text: "SWIFT_TARIFF_BLOCK_ITEM_TEXT_3"
      },
      {
        id: 4,
        type: "SWIFT_TARIFF_BLOCK_ITEM_TYPE_4",
        text: "SWIFT_TARIFF_BLOCK_ITEM_TEXT_4"
      }
    ]
  };

  const dropdown1Data = {
    headers: ["SWIFT_TARIFF_HEADER_TYPE", "SWIFT_TARIFF_HEADER_TEXT"],
    columns: ["type", "text"],
    data: [
      {
        id: 1,
        type: "SWIFT_TARIFF_BLOCK_ITEM_TYPE_5",
        text: "SWIFT_TARIFF_BLOCK_ITEM_TEXT_5"
      },
      {
        id: 2,
        type: "SWIFT_TARIFF_BLOCK_ITEM_TYPE_6",
        text: "SWIFT_TARIFF_BLOCK_ITEM_TEXT_6"
      }
    ]
  };

  const dropdown2Data = {
    headers: ["SWIFT_TARIFF_HEADER_TYPE", "SWIFT_TARIFF_HEADER_TEXT"],
    columns: ["type", "text"],
    data: [
      {
        id: 1,
        type: "SWIFT_TARIFF_BLOCK_ITEM_TYPE_7",
        text: "SWIFT_TARIFF_BLOCK_ITEM_TEXT_7"
      },
      {
        id: 2,
        type: "SWIFT_TARIFF_BLOCK_ITEM_TYPE_8",
        text: "SWIFT_TARIFF_BLOCK_ITEM_TEXT_8"
      }
    ]
  };

  const dropdown3Data = {
    headers: ["SWIFT_TARIFF_HEADER_TYPE", "SWIFT_TARIFF_HEADER_TEXT"],
    columns: ["type", "text"],
    data: [
      {
        id: 1,
        type: "SWIFT_TARIFF_BLOCK_ITEM_TYPE_9",
        text: "SWIFT_TARIFF_BLOCK_ITEM_TEXT_9"
      },
      {
        id: 2,
        type: "SWIFT_TARIFF_BLOCK_ITEM_TYPE_10",
        text: "SWIFT_TARIFF_BLOCK_ITEM_TEXT_10"
      }
    ]
  };

  const dropdown4Data = {
    headers: ["SWIFT_TARIFF_HEADER_TYPE", "SWIFT_TARIFF_HEADER_TEXT"],
    columns: ["type", "text"],
    data: [
      {
        id: 1,
        type: "SWIFT_TARIFF_BLOCK_ITEM_TYPE_11",
        text: "SWIFT_TARIFF_BLOCK_ITEM_TEXT_11"
      }
    ]
  };

  return (
    <div className="swift-new">
      <Hero
        data={hero_data}
        img={banner_img}
        className="transfers"
        page={page}
      />
      <div className="content">
        {!this.state.faqTab ? (
          <>
            <InfoBlock
              title="SWIFT_HOW_TO_BLOCK_TITLE"
              text="SWIFT_HOW_TO_BLOCK_DESC"
            />
            {tooltip}
            <InfoBlock
              text="SWIFT_HOW_TO_BLOCK_DESC_2"
            />
            <div>
              <div className="wartime-tariffs">
                <TransferTableNew data={wartimeTariffsData} title={'SWIFT_WARTIME_TARIFFS_TITLE'} titleTag={"div"}/>
                <div className="container">
                  <div className="wartime-tariffs__hint">{this.l10n('SWIFT_WARTIME_TARIFFS_HINT')}</div>
                </div>
              </div>
              <TransferTableNew data={purposeBlockData} />
              <div className="swift-new__purpose-star-text">
                <div className="container">
                  {this.l10n("SWIFT_PURPOSE_BLOCK_STAR_TEXT")}
                </div>
              </div>
              <div className="swift-new__purpose-star-list">
                <div className="container">
                  <div className="swift-new__purpose-star-list-title">{this.l10n(purposeStarListData.title)}</div>
                  <ul>
                    {purposeStarListData.items.map((item, index) => (
                      <li key={index}>{this.l10n(item)}</li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
            <div className="swift-new__tariffs tariffs-swift-new">
              <TitleBlock title={tariffBlockData.title}/>
              <TransferTableNew data={tariffBlockData} />
              <CustomDropdownNew title={this.l10n("SWIFT_TARIFF_BLOCK_DROPDOWN_TITLE_1")} page={page} id={'tariff-dropdown-1'}>
                <div>
                  <TransferTableNew data={dropdown1Data} />
                </div>
              </CustomDropdownNew>
              <CustomDropdownNew title={this.l10n("SWIFT_TARIFF_BLOCK_DROPDOWN_TITLE_2")} page={page} id={'tariff-dropdown-2'}>
                <div>
                  <TransferTableNew data={dropdown2Data} />
                </div>
              </CustomDropdownNew>
              <CustomDropdownNew title={this.l10n("SWIFT_TARIFF_BLOCK_DROPDOWN_TITLE_3")} page={page} id={'tariff-dropdown-3'}>
                <div>
                  <TransferTableNew data={dropdown3Data} />
                </div>
              </CustomDropdownNew>
              <CustomDropdownNew title={this.l10n("SWIFT_TARIFF_BLOCK_DROPDOWN_TITLE_4")} page={page} id={'tariff-dropdown-4'}>
                <div>
                  <TransferTableNew data={dropdown4Data} />
                </div>
                <div className="tariffs-swift-new__disclaimer">
                  <div className="container">
                    {this.l10n("SWIFT_TARIFF_BLOCK_ITEM_TEXT_12")}
                  </div>
                </div>
              </CustomDropdownNew>
            </div>
            <div className="swift-new__info-block">
              <InfoBlock
                text="SWIFT_HOW_TO_BLOCK_DESC_3"
              />
              <div className="attention-block">
                <div className="container">
                  <div className="attention-block__body">
                    <div className="attention-block__title">
                      <ReactSVG src={attention_icon} className="attention-block__icon"/>
                      {this.l10n('SWIFT_HINT_TITLE')}
                    </div>
                    <div className="attention-block__text">
                      <p><b>{this.l10n('SWIFT_HINT_SUBTITLE_1')}</b></p>
                      <p>{this.l10n('SWIFT_HINT_LIST_ITEM_1')}</p>
                      <p><b>{this.l10n('SWIFT_HINT_SUBTITLE_2')}</b></p>
                      <ul>
                        <li dangerouslySetInnerHTML={{__html: this.l10n('SWIFT_HINT_LIST_ITEM_2')}}></li>
                        <li dangerouslySetInnerHTML={{__html: this.l10n('SWIFT_HINT_LIST_ITEM_3')}}></li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <QuestionsAdminNew
              widget={questionsWidget}
              toggleFaqTab={this.toggleFaqTab}
              title={'FAQ_SHORT_NEW_TITLE'}
              page={page}
            />
            <FilesForDownloadNew
              page={'new-design'}
              lang={this.props.lang}
              widget={this.widgetsHelper.getWidget.call(this, "files_to_download")}
            />
          </>
        ) : (
          <FAQStorybook
            widget={questionsWidget}
            title={this.l10n('YELLOW_CARD_NEW_FAQ_STORYBOOK_TITLE')}
            btnText={this.l10n('YELLOW_CARD_NEW_FAQ_STORYBOOK_BTN_TEXT')}
            onBtnClick={this.toggleFaqTab}
            filterByEnvironment={filterByEnvironment}
          />
        )}
      </div>
    </div>
  );
}
